<template>
  <div class="body-box marginBox">
    <!-- 搜索与添加区域 -->
    <el-row class="plan">
      <el-col :span="19">
        <el-button icon="el-icon-plus" @click="addLabel">新增</el-button>
      </el-col>

      <el-col :span="5">
        <search-input  v-model="queryInfo.keyword" placeholder="请输入关键字进行搜索" @change="handleQuery"/>
      </el-col>
    </el-row>

    <el-table :height="'calc(100% - 70px)'" :data="labelList" class="button-box">
      <el-table-column label="名称" prop="name"></el-table-column>
      <el-table-column label="图标" prop="icon">
        <template slot-scope="scope">
          <el-image
            style="width: 80px; height: 30px"
            :src="`${getaway.user}bt/file/${scope.row.icon}/download`"
            fit="cover"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180px">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" @click="editLabel(scope.row)">修改</el-button>
          <el-button icon="el-icon-delete" @click="removeLabelById(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="fixedBox"><pagination ref="page" :query-param.sync="queryInfo" @pagination="getLabelList" /></div>

    <addLabel @refresh-list="handleQuery" ref="addLabel"></addLabel>
    <editLabel @refresh-list="handleQuery" ref="editLabel"></editLabel>
  </div>
</template>
<script>
import Pagination from '@/components/common/Pagination/index'
import addLabel from '@/views/label/addLabel'
import editLabel from '@/views/label/editLabel'
import { getPostOrDeleteData } from '@/utils/code'
import { deleteLabel, getLabelList } from '@/api/label/label'
import { deleteTips, title } from '@/utils/tips'
import SearchInput from '@/components/common/searchInput/searchInput'

export default {
  components: { SearchInput, Pagination, addLabel, editLabel },
  data() {
    return {
      // 查询参数
      queryInfo: {
        keyword: ''
      },
      labelList: []
    }
  },
  created() {
    this.handleQuery()
  },
  methods: {
    //查询列表
    getLabelList(page, cb) {
      getLabelList(page).then((response) => {
        this.labelList = cb(response)
      })
    },

    //根据ID删除数据
    async removeLabelById(id) {
      let b = await deleteTips(title.deleteTitle)
      if (b) {
        deleteLabel(id).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.handleQuery()
          }
        })
      }
    },

    //新增
    addLabel() {
      this.$refs.addLabel.addDialog()
    },

    //修改
    editLabel(row) {
      this.$refs.editLabel.editDialog(row)
    },

    //查询按钮
    handleQuery() {
      this.$nextTick(() => {
        this.$refs.page.run()
      })
    },

  }
}
</script>

<style lang="less" scoped>

</style>
